var $01ed20b257e7f1cc$exports = {};
$01ed20b257e7f1cc$exports = {
    "replaceMessage": `Lai aizst\u{101}tu, nometiet failu`
};


export {$01ed20b257e7f1cc$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
